import { Link } from "react-router-dom";
import { useState } from "react";
import { X } from "lucide-react";

const BlogCTAButtons = () => {
  const [showCalendly, setShowCalendly] = useState(false);

  return (
    <>
      <div className="mt-12 flex items-center justify-center gap-6">
        <Link
          to="/what-fits-my-lot"
          className="px-8 py-4 rounded-2xl bg-white text-foreground font-medium text-lg shadow-[8px_8px_16px_#d0d0d0,-8px_-8px_16px_#ffffff] hover:shadow-[10px_10px_20px_#c8c8c8,-10px_-10px_20px_#ffffff] transition-all duration-300 no-underline"
        >
          What fits my lot?
        </Link>
        <button
          onClick={() => setShowCalendly(true)}
          className="px-8 py-4 rounded-2xl bg-white text-foreground font-medium text-lg shadow-[8px_8px_16px_#d0d0d0,-8px_-8px_16px_#ffffff] hover:shadow-[10px_10px_20px_#c8c8c8,-10px_-10px_20px_#ffffff] transition-all duration-300 cursor-pointer"
        >
          Schedule
        </button>
      </div>

      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button
              onClick={() => setShowCalendly(false)}
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BlogCTAButtons;
